import React, { useState } from 'react'
import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import { apiGet } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'

const RESOURCE_TYPE_ENDPOINTS = {
  PART_REFERENCE: 'partReferencesPagination',
  RAW_MATERIAL_REFERENCE: 'rawMaterialsReference/paginated'
}

/**
 * CatalogComponentPicker — S33 (historia 117 HU-03/RN-03.3/RN-G11). Components are only ever added
 * from the existing catalog (PartReference / RawMaterialReference), picked through a search table —
 * never by typing a free code, and never creating a new catalog entry on the fly.
 * @param {(row: object, resourceType: string) => void} props.onSelect
 */
const CatalogComponentPicker = ({ onClose, onSelect }) => {
  const { t_ } = useSmartTranslation()
  const [resourceType, setResourceType] = useState('PART_REFERENCE')

  return (
    <SmartDialog
      setOpen
      title={{ render: <Typography variant='h6'>{t_('Add from catalog')}</Typography> }}
      accept={false}
      cancel={false}
      close
      closeCallback={onClose}
      paperWidth='60rem'
      renderComponent={
        <Stack spacing={2} sx={{ textAlign: 'left' }} data-testid='catalog-component-picker'>
          <ToggleButtonGroup
            value={resourceType}
            exclusive
            size='small'
            onChange={(event, value) => { if (value) setResourceType(value) }}
          >
            <ToggleButton value='PART_REFERENCE'>{t_('Part')}</ToggleButton>
            <ToggleButton value='RAW_MATERIAL_REFERENCE'>{t_('Raw material')}</ToggleButton>
          </ToggleButtonGroup>
          <SmartMateriaUITable
            key={resourceType}
            columns={[{ name: t_('Code'), field: 'code' }, { name: t_('Name'), field: 'name' }]}
            dataFetch={(pagination) => apiGet(RESOURCE_TYPE_ENDPOINTS[resourceType], pagination)}
            pageable
            primaryKeys={['id']}
            onRowClick={(row) => onSelect(row, resourceType)}
          />
        </Stack>
      }
    />
  )
}

export default CatalogComponentPicker
